import { colors } from '../../../../packages/colors';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  primaryBtn: {
    color: colors.white,
    padding: '10px 16px',
  },
});
